var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"winPage"},[_c('h1',[_vm._v("V你50")]),_c('div',{on:{"click":function($event){return _vm.playAgian()}}},[_vm._v("我还要")]),_c('div',{on:{"click":function($event){return _vm.back()}}},[_vm._v("够了")])])}
var staticRenderFns = []

export { render, staticRenderFns }